<ng-container *ngIf="surveys$ | async as surveys">
  <ps-ui-surveys-table
    [tableHeaders]="constants.MC_SURVEY_TABLE_HEADERS"
    [surveys]="surveys"
    [isSingleCountrySurvey]="isSingleCountrySurvey"
  ></ps-ui-surveys-table>
</ng-container>
